/**
 * Kaladé Skin Quiz — Dawn Theme
 * Logic Architecture v3
 * Routines feel believable, commercial and journey-appropriate
 * Q2 and Q7 are multi-select, all others single-select
 */

document.addEventListener('DOMContentLoaded', function() {
(function () {
  'use strict';

  var IMAGES = {
    ceo:           'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/Kalade-CEOCleanser_bbaa2247-d276-4511-af82-152cec551a71.jpg?v=1770066251',
    iykyk:         'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/IYKYK_DAILY_MOISTURISER_c50f93c7-4973-46a5-b867-090d81f872b1.png?v=1774849989',
    goldy:         'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/AMSerum.jpg?v=1764196845',
    glowup:        'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/FaceOil.jpg?v=1764209859',
    dream:         'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/PMSerum.jpg?v=1764196832',
    exfoli:        'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/Kalade-Exfoli-YayBWcopy.jpg?v=1764200790',
    hydration:     'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/BodyLotion.jpg?v=1764209859',
    pitlime:       'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/LimeDEO.jpg?v=1774335394',
    pitgrapefruit: 'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/GrapefruitDEO.jpg?v=1774847124',
  };

  var BUNDLE_IMAGES = {
    'starter-trio':           'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/Bundle-Face_140aa35d-115f-4f05-a378-a80b16ea4b71.jpg?v=1764209807',
    'og-starter-kit':         'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/Bundle-OG_2586e5bc-661d-4ff0-88fd-fbf0259dc827.jpg?v=1764211042',
    'am-pm-bundle':           'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/Day-to-Nighty_Hydration.jpg?v=1777512435',
    'essential-four':         'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/Essential_Four.jpg?v=1777512519',
    'complete-face-edit':     'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/COMPLETEFACE.png?v=1773659032',
    'complete-skincare-edit': 'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/COMPLETESKINCAREBUNDLE.png?v=1774859517',
    'complete-body-bundle':   'https://cdn.shopify.com/s/files/1/0631/9803/6121/files/COMPLETEBODYBUNDLE.png?v=1773660675',
  };

  var QUESTIONS = [
    {
      id: 'q1',
      text: "What's been going on with your skin lately?",
      options: [
        { label: 'My skin reacts to everything',                    key: 'reacts_to_everything' },
        { label: "Redness / irritation that won't go away",         key: 'redness_irritation' },
        { label: 'Breakouts that come and go',                      key: 'breakouts_come_go' },
        { label: 'Dry, tight, uncomfortable skin',                  key: 'dry_tight_uncomfortable' },
        { label: 'My skin just feels inconsistent',                 key: 'inconsistent_skin' },
        { label: "I don't know where to start",                     key: 'dont_know_where_to_start' },
        { label: "I'm just looking for a general skincare routine", key: 'general_skincare_routine' },
      ]
    },
    {
      id: 'q2_body',
      multi: true,
      text: 'Do you experience any skin concerns on your body?',
      options: [
        { label: 'Body breakouts — back, chest or shoulders',   key: 'body_breakouts' },
        { label: 'Rough or bumpy skin',                         key: 'rough_bumpy_skin' },
        { label: 'Dry / itchy skin',                            key: 'dry_itchy_skin' },
        { label: 'Ingrown hairs',                               key: 'ingrown_hairs' },
        { label: 'Sensitive underarms / deodorant irritation',  key: 'sensitive_underarms_deodorant_irritation' },
        { label: 'No body concerns',                            key: 'no_body_concerns' },
      ]
    },
    {
      id: 'q3',
      text: 'How does your skin usually feel as the day goes on?',
      options: [
        { label: 'Tight and dry',            key: 'tight_and_dry' },
        { label: 'Oily or shiny',            key: 'oily_or_shiny' },
        { label: 'A mix of both',            key: 'mix_of_both' },
        { label: 'Irritated or sensitive',   key: 'irritated_or_sensitive' },
        { label: 'Pretty normal / balanced', key: 'normal_balanced' },
      ]
    },
    {
      id: 'q4',
      text: 'Has your skin ever reacted badly to a product before?',
      options: [
        { label: 'Yes, all the time',  key: 'yes_all_the_time' },
        { label: 'Yes, a few times',   key: 'yes_a_few_times' },
        { label: 'Rarely',             key: 'rarely' },
        { label: 'Never',              key: 'never' },
      ]
    },
    {
      id: 'q5',
      text: 'How does your skin tend to behave over time?',
      options: [
        { label: 'Starts okay, then becomes irritated', key: 'starts_okay_then_irritated' },
        { label: 'Feels dry no matter what I use',      key: 'feels_dry_no_matter_what' },
        { label: 'Breaks out easily',                   key: 'breaks_out_easily' },
        { label: 'Pretty stable',                       key: 'pretty_stable' },
        { label: 'Changes all the time',                key: 'changes_all_the_time' },
      ]
    },
    {
      id: 'q6',
      text: 'What does your skincare routine look like right now?',
      options: [
        { label: "I don't really have one",            key: 'no_routine' },
        { label: 'Just 1-2 products',                  key: 'one_to_two_products' },
        { label: 'A few products, but inconsistent',   key: 'few_products_but_inconsistent' },
        { label: 'A full routine with multiple steps', key: 'full_routine_multiple_steps' },
        { label: "I'm always switching products",      key: 'always_switching_products' },
      ]
    },
    {
      id: 'q7',
      multi: true,
      text: 'What are you really looking for from your skincare?',
      options: [
        { label: "Something gentle that won't irritate my skin", key: 'gentle_wont_irritate' },
        { label: 'Simple, easy routines',                        key: 'simple_easy_routines' },
        { label: 'Clear, visible results',                       key: 'clear_visible_results' },
        { label: 'Hydration that actually lasts',                key: 'hydration_that_lasts' },
        { label: 'Products I can trust for sensitive skin',      key: 'trust_for_sensitive_skin' },
      ]
    },
    {
      id: 'q8_age',
      text: 'Which age range do you fall into?',
      options: [
        { label: 'Under 18', key: 'under_18',    ageNumber: 17 },
        { label: '18-24',    key: 'age_18_24',   ageNumber: 24 },
        { label: '25-34',    key: 'age_25_34',   ageNumber: 30 },
        { label: '35-44',    key: 'age_35_44',   ageNumber: 40 },
        { label: '45+',      key: 'age_45_plus', ageNumber: 45 },
      ]
    }
  ];

  var Q1_MAP = {
    reacts_to_everything:     { sensitive: 3, barrier: 2 },
    redness_irritation:       { sensitive: 3, barrier: 2 },
    breakouts_come_go:        { breakouts: 3, inconsistent: 2 },
    dry_tight_uncomfortable:  { dehydrated: 3, barrier: 1 },
    inconsistent_skin:        { inconsistent: 3, barrier: 1 },
    dont_know_where_to_start: { simple: 5 },
    general_skincare_routine: { simple: 3 },
  };

  var Q2_MAP = {
    body_breakouts:                           { bodyBreakouts: 3, breakouts: 1 },
    rough_bumpy_skin:                         { bodyTexture: 3 },
    dry_itchy_skin:                           { bodyDryness: 3, dehydrated: 1 },
    ingrown_hairs:                            { bodyTexture: 2 },
    sensitive_underarms_deodorant_irritation: { bodySensitivity: 3, sensitive: 1 },
    no_body_concerns:                         {},
  };

  var Q3_MAP = {
    tight_and_dry:          { dehydrated: 3 },
    oily_or_shiny:          { breakouts: 2, inconsistent: 1 },
    mix_of_both:            { inconsistent: 2, breakouts: 1, dehydrated: 1 },
    irritated_or_sensitive: { sensitive: 3, barrier: 2 },
    normal_balanced:        {},
  };

  var Q4_MAP = {
    yes_all_the_time: { sensitive: 3, barrier: 2 },
    yes_a_few_times:  { sensitive: 2, barrier: 1 },
    rarely:           {},
    never:            {},
  };

  var Q5_MAP = {
    starts_okay_then_irritated: { barrier: 3, sensitive: 2 },
    feels_dry_no_matter_what:   { dehydrated: 4, barrier: 1 },
    breaks_out_easily:          { breakouts: 4 },
    pretty_stable:              {},
    changes_all_the_time:       { inconsistent: 4, barrier: 1 },
  };

  var Q6_ROUTINE_LEVEL = {
    no_routine:                    'none',
    one_to_two_products:           'minimal',
    few_products_but_inconsistent: 'some',
    full_routine_multiple_steps:   'full',
    always_switching_products:     'some',
  };

  var Q6_MAP = {
    no_routine:                    { simple: 5 },
    one_to_two_products:           { simple: 4 },
    few_products_but_inconsistent: { simple: 1, inconsistent: 2 },
    full_routine_multiple_steps:   { simple: -3 },
    always_switching_products:     { inconsistent: 3, barrier: 1 },
  };

  var Q7_MAP = {
    gentle_wont_irritate:     { sensitive: 2, barrier: 1 },
    simple_easy_routines:     { simple: 4 },
    clear_visible_results:    { wantsResults: 3, breakouts: 1 },
    hydration_that_lasts:     { dehydrated: 3, wantsResults: 1 },
    trust_for_sensitive_skin: { sensitive: 2, barrier: 1 },
  };

  var PRODUCTS = {
    cleanser:    { name: 'CEO of Cleanser',           desc: 'Gentle, pH-balanced cleanser that removes buildup without stripping your skin.',                                                                                                  img: 'ceo',       url: '/products/ceo-of-cleanser' },
    moisturiser: { name: 'IYKYK Daily Moisturiser',   desc: 'Lightweight, fragrance-free hydration that supports your skin barrier.',                                                                                                         img: 'iykyk',     url: '/products/iykyk-daily-moisturiser' },
    glowOil:     { name: 'Glow Up Face Oil',          desc: 'Nourishing face oil that seals in hydration and supports your barrier — the final step that makes a routine feel complete.',                                                     img: 'glowup',    url: '/products/glow-up' },
    goldy:       { name: 'Goldy AM Serum',            desc: '5% Niacinamide and multi-weight Hyaluronic Acid. Helps visibly balance oil, calm redness and support hydration — gentle enough for sensitive and breakout-prone skin.',          img: 'goldy',     url: '/products/goldy-am-serum' },
    dream:       { name: 'Dream PM Serum',            desc: 'Overnight support serum that helps restore hydration and skin balance while you sleep. Lightweight and non-stripping — especially good for breakout-prone and inconsistent skin.', img: 'dream',     url: '/products/dream-pm-serum' },
    exfoli:      { name: 'Exfoli-YAY Body Wash',      desc: 'Gentle AHA + BHA body wash to smooth rough, bumpy skin and target body breakouts without harsh scrubs.',                                                                         img: 'exfoli',    url: '/products/exfoli-yay-body-wash' },
    hydration:   { name: 'Hydration Era Body Lotion', desc: 'Lightweight body lotion that hydrates dry, sensitive skin without greasy residue.',                                                                                              img: 'hydration', url: '/products/hydration-era' },
    deodorant:   { name: 'Pit Perfect Deodorant',     desc: 'Aluminium-free and baking soda-free deodorant designed for sensitive underarm skin.',                                                                                            img: 'pitlime',   url: '/products/pit-perfect-deodorant' },
  };

  var ROUTINE_SIMPLE = [
    { step: 'Step 01 — Cleanse',  product: 'cleanser' },
    { step: 'Step 02 — Hydrate',  product: 'moisturiser' },
    { step: 'Step 03 — Nourish',  product: 'glowOil' },
  ];

  var ROUTINE_TEEN = [
    { step: 'Step 01 — Cleanse',  product: 'cleanser' },
    { step: 'Step 02 — AM Serum', product: 'goldy' },
    { step: 'Step 03 — Hydrate',  product: 'moisturiser' },
    { step: 'Step 04 — Nourish',  product: 'glowOil' },
  ];

  var ROUTINE_ADULT_BREAKOUT = [
    { step: 'Step 01 — Cleanse',    product: 'cleanser' },
    { step: 'Step 02 — AM Serum',   product: 'goldy' },
    { step: 'Step 03 — Hydrate',    product: 'moisturiser' },
    { step: 'Step 04 — PM Support', product: 'dream' },
  ];

  var ROUTINE_SENSITIVE = [
    { step: 'Step 01 — Cleanse',  product: 'cleanser' },
    { step: 'Step 02 — Hydrate',  product: 'moisturiser' },
    { step: 'Step 03 — Nourish',  product: 'glowOil' },
  ];

  var ROUTINE_COMPLETE = [
    { step: 'Step 01 — Cleanse',        product: 'cleanser' },
    { step: 'Step 02 — AM Serum',       product: 'goldy' },
    { step: 'Step 03 — Hydrate',        product: 'moisturiser' },
    { step: 'Step 04 — PM Serum',       product: 'dream' },
    { step: 'Step 05 — Seal & Nourish', product: 'glowOil' },
  ];

  var PROFILE_COPY = {
    reactive_sensitive: {
      title: 'Reactive & Easily Triggered Skin',
      why: "Your answers show your skin reacts quickly — redness, irritation or that 'everything stings' feeling. Your barrier may be struggling to stay balanced, which creates a cycle of sensitivity that's hard to break.",
      mistake: 'Switching products too often, or using too many actives, keeps feeding the cycle. Your skin needs consistency and calm.',
      routineNote: 'This routine keeps things gentle and consistent — the foundation your skin needs to feel balanced and settled.',
    },
    sensitive_breakout: {
      title: 'Breaking Out — But Still Sensitive',
      why: "Your skin is dealing with breakouts but also reacts easily. Harsh acne products can make things worse. What your skin actually needs is gentle, targeted support — Niacinamide helps visibly calm breakouts without stripping or irritating.",
      mistake: 'Over-stripping triggers more oil and more breakouts. The goal is balance, not aggression.',
      routineNote: 'This routine supports clearer-looking skin while keeping your barrier calm and hydrated.',
    },
    dry_dehydrated: {
      title: 'Dry, Tight & Not Holding Hydration',
      why: "Your skin isn't just dry — it may be struggling to hold onto hydration. This is a barrier issue as much as a moisture issue, which is why tightness keeps coming back no matter what you use.",
      mistake: "Heavy creams alone don't solve dehydration. Your skin needs layered hydration — serum, moisturiser and a barrier-sealing oil working together.",
      routineNote: 'This routine layers hydration from the inside out — giving your skin the tools to stay comfortable all day.',
    },
    breakout_prone: {
      title: 'Breakout-Prone But Needs Balance',
      why: "Your skin breaks out easily and needs targeted support — not stripping. Niacinamide helps visibly balance oil, calm redness and support hydration without feeling heavy.",
      mistake: 'Going too harsh strips your barrier and triggers more oil and more breakouts. Gentle balance consistently outperforms aggressive treatment.',
      routineNote: 'This routine supports clearer, more balanced skin — AM serum to target, PM serum to restore.',
    },
    teen_breakout: {
      title: 'Young Skin That Needs Gentle Support',
      why: "Breakouts are completely normal for younger skin. Hormonal changes affect oil production — but the solution isn't harsh products. Niacinamide gently helps calm breakouts, support balance and keep your skin barrier healthy.",
      mistake: "Harsh washes and stripping toners make things worse by drying your skin out and triggering more oil. Gentle and consistent is the move.",
      routineNote: 'This routine is simple, supportive and designed to feel manageable — not overwhelming.',
    },
    inconsistent_unpredictable: {
      title: 'Inconsistent & Unpredictable Skin',
      why: "Some days dry, other days breaking out, sometimes irritated for no clear reason. Unpredictable skin usually points to a barrier that needs consistent support to find its balance.",
      mistake: 'Switching products frequently keeps your skin stuck in the same cycle. Staying consistent with the right routine is what finally breaks it.',
      routineNote: 'This routine helps bring your skin back to a calmer, more predictable place — one consistent step at a time.',
    },
    simple_reset: {
      title: 'Your Skin Needs a Simple Reset',
      why: "You're not looking for a complicated routine. You want something easy, gentle and effective — and that's exactly the right place to start.",
      mistake: "More products doesn't always mean better skin. A simple routine done consistently will always beat a complicated one you can't stick to.",
      routineNote: 'Start simple, stay consistent. When your skin is ready for more, you will know.',
    },
  };

  var ROUTINE_COPY = {
    simple:         { heading: 'Your Routine',          note: 'Three steps that cover what your skin needs right now. Clean, hydrate, nourish.' },
    teen:           { heading: 'Your Routine',          note: 'Built to be gentle and manageable — cleanse, support with Niacinamide, hydrate and nourish.' },
    adult_breakout: { heading: 'Your Routine',          note: 'AM serum to support balance during the day. PM serum to restore overnight. No unnecessary steps.' },
    sensitive:      { heading: 'Your Routine',          note: 'Gentle and consistent — the three steps your skin needs to feel calm and settled.' },
    complete:       { heading: 'Your Complete Routine', note: 'Full hydration layering — morning and night. Every step earns its place.' },
  };

  var BUNDLE_COPY = {
    'starter-trio': {
      name: 'Starter Trio', headline: 'The simplest place to start.',
      desc: 'Cleanse, hydrate and nourish — everything you need to build a gentle, consistent face routine.',
      cta: 'Shop the Starter Trio', url: '/products/starter-trio', img: 'starter-trio',
    },
    'og-starter-kit': {
      name: 'OG Starter Kit', headline: 'Face and body, simply covered.',
      desc: 'The Starter Trio plus Hydration Era Body Lotion — gentle face and body support in one easy kit.',
      cta: 'Shop the OG Starter Kit', url: '/products/kalade-og-kit', img: 'og-starter-kit',
    },
    'am-pm-bundle': {
      name: 'AM/PM Bundle', headline: 'Ready to level up?',
      desc: 'Goldy AM Serum and Dream PM Serum — the upgrade for hydration, balance and visible skin support morning and night.',
      cta: 'Shop the AM/PM Bundle', url: '/products/the-am-pm-bundle', img: 'am-pm-bundle',
    },
    'essential-four': {
      name: 'Essential Four', headline: 'Face and body support, all in one.',
      desc: 'CEO Of Cleanser, IYKYK Daily Moisturiser, Glow Up Face Oil and Hydration Era Body Lotion — gentle coverage for face and body.',
      cta: 'Shop the Essential Four', url: '/products/essential-four-bundle', img: 'essential-four',
    },
    'complete-face-edit': {
      name: 'Complete Face Edit', headline: 'Everything your skin needs in one routine.',
      desc: 'CEO Of Cleanser, Goldy AM Serum, IYKYK Daily Moisturiser, Dream PM Serum and Glow Up Face Oil — a complete face routine for visible, lasting results.',
      cta: 'Shop the Complete Face Edit', url: '/products/complete-face-edit', img: 'complete-face-edit',
    },
    'complete-skincare-edit': {
      name: 'Complete Skincare Edit', headline: 'Face, body and underarms — all covered.',
      desc: 'The full Kaladé setup. Everything from your Complete Face Edit plus body wash, body lotion and deodorant.',
      cta: 'Shop the Complete Skincare Edit', url: '/products/complete-skincare-edit', img: 'complete-skincare-edit',
    },
    'complete-body-bundle': {
      name: 'Complete Body Bundle', headline: 'Your full body routine, sorted.',
      desc: 'Exfoli-YAY Body Wash, Hydration Era Body Lotion and Pit Perfect Deodorant — everything for smooth, hydrated, comfortable body skin.',
      cta: 'Shop the Complete Body Bundle', url: '/products/complete-body-bundle', img: 'complete-body-bundle',
    },
  };

  function applyMap(scores, map, key) {
    if (!map[key]) return;
    var entries = map[key];
    Object.keys(entries).forEach(function(k) { scores[k] = (scores[k] || 0) + entries[k]; });
  }

  function getSkinProfile(scores, ageNumber) {
    if (ageNumber <= 17 && scores.breakouts >= 2)        return 'teen_breakout';
    if (scores.sensitive >= 6 && scores.breakouts >= 3)  return 'sensitive_breakout';
    if (scores.sensitive >= 6 || scores.barrier >= 5)    return 'reactive_sensitive';
    if (scores.dehydrated >= 5)                          return 'dry_dehydrated';
    if (scores.breakouts >= 5)                           return 'breakout_prone';
    if (scores.inconsistent >= 5)                        return 'inconsistent_unpredictable';
    return 'simple_reset';
  }

  function getRoutineAndBundles(scores, routineLevel, goalFlags, ageNumber, bodyProdCount) {
    var isTeen          = ageNumber <= 17;
    var isBreakoutProne = scores.breakouts >= 3;
    var isVeryDry       = scores.dehydrated >= 6;
    var isDehydrated    = scores.dehydrated >= 4;
    var isInconsistent  = scores.inconsistent >= 4;
    var isSensitive     = scores.sensitive >= 4 || scores.barrier >= 4;
    var isHighSensitive = scores.sensitive >= 6 || scores.barrier >= 5;
    var wantsResults    = goalFlags.wantsResults || scores.wantsResults >= 2;
    var hasRoutine      = routineLevel === 'full' || routineLevel === 'some';
    var isFullRoutine   = routineLevel === 'full';

    if (isTeen && isBreakoutProne) {
      return { routine: ROUTINE_TEEN, routineLevel: 'teen', primaryBundle: 'starter-trio', upgradeBundle: 'am-pm-bundle' };
    }
    if (isHighSensitive && !isBreakoutProne) {
      if (goalFlags.hasBodyConcerns) {
        return { routine: ROUTINE_SENSITIVE, routineLevel: 'sensitive', primaryBundle: 'essential-four', upgradeBundle: 'am-pm-bundle' };
      }
      return { routine: ROUTINE_SENSITIVE, routineLevel: 'sensitive', primaryBundle: 'starter-trio', upgradeBundle: 'am-pm-bundle' };
    }
    var qualifiesComplete = (
      isVeryDry || (isDehydrated && hasRoutine) || (isDehydrated && wantsResults) ||
      (isDehydrated && isSensitive) || (isFullRoutine && (isDehydrated || isInconsistent || wantsResults))
    );
    if (qualifiesComplete) {
      return { routine: ROUTINE_COMPLETE, routineLevel: 'complete', primaryBundle: 'complete-face-edit', upgradeBundle: 'complete-skincare-edit' };
    }
    if (isBreakoutProne && !isTeen) {
      return { routine: ROUTINE_ADULT_BREAKOUT, routineLevel: 'adult_breakout', primaryBundle: 'complete-face-edit', upgradeBundle: 'am-pm-bundle' };
    }
    if ((isInconsistent || wantsResults) && hasRoutine) {
      return { routine: ROUTINE_COMPLETE, routineLevel: 'complete', primaryBundle: 'complete-face-edit', upgradeBundle: 'complete-skincare-edit' };
    }
    if (goalFlags.hasBodyDryness) {
      return { routine: ROUTINE_SIMPLE, routineLevel: 'simple', primaryBundle: 'og-starter-kit', upgradeBundle: 'am-pm-bundle' };
    }
    return { routine: ROUTINE_SIMPLE, routineLevel: 'simple', primaryBundle: 'starter-trio', upgradeBundle: 'am-pm-bundle' };
  }

  function getBodyProds(bodyAnswers, hasNoBody) {
    if (hasNoBody) return [];
    var products = [];
    if (bodyAnswers.indexOf('body_breakouts') > -1 || bodyAnswers.indexOf('rough_bumpy_skin') > -1 || bodyAnswers.indexOf('ingrown_hairs') > -1) products.push('exfoli');
    if (bodyAnswers.indexOf('dry_itchy_skin') > -1) products.push('hydration');
    if (bodyAnswers.indexOf('sensitive_underarms_deodorant_irritation') > -1) products.push('deodorant');
    return products;
  }

  function getSerumEducation(scores, ageNumber, routine) {
    var blocks = [];
    var hasGoldy        = routine.some(function(r) { return r.product === 'goldy'; });
    var hasDream        = routine.some(function(r) { return r.product === 'dream'; });
    var isBreakoutProne = scores.breakouts >= 4;
    var isSensitive     = scores.sensitive >= 6 || scores.barrier >= 5;
    var isTeen          = ageNumber <= 17;
    if (!hasGoldy && !hasDream && !isTeen) return blocks;
    if (isTeen) {
      blocks.push({ title: 'A simple routine for younger skin', body: 'Younger skin does not need an overcomplicated routine. Your recommendation has been built to keep things gentle, simple and supportive — with lightweight formulas that help hydrate and balance the skin.' });
    }
    if (hasGoldy && isBreakoutProne) {
      blocks.push({ title: 'Why Goldy AM Serum suits breakout-prone skin', body: 'Breakout-prone skin still needs hydration and barrier support. Goldy AM Serum contains 5% Niacinamide and multi-weight Hyaluronic Acid to help visibly balance oil, support hydration and keep skin feeling comfortable — without a heavy finish.' });
    } else if (hasGoldy && !isTeen) {
      blocks.push({ title: 'Why Goldy AM Serum is included', body: 'Goldy AM Serum brings gentle daily support with 5% Niacinamide and multi-weight Hyaluronic Acid — supporting hydration, visible balance and a more even-looking skin tone without any heavy feel.' });
    }
    if (hasDream) {
      blocks.push({ title: 'Why Dream PM Serum is included', body: 'Dream PM Serum supports overnight hydration and skin balance. Lightweight and non-stripping — a good fit for skin that feels dry, reactive or inconsistent, and wants to wake up feeling more settled.' });
    }
    if (isSensitive && hasGoldy && !isBreakoutProne) {
      blocks.push({ title: 'Gentle support for sensitive-feeling skin', body: 'When skin feels reactive, harsh products almost always make things worse. This routine focuses on lightweight hydration, barrier support and formulas designed with sensitive skin in mind.' });
    }
    return blocks;
  }

  function computeResults(answers, bodyAnswers, goalAnswers, ageKey, ageNumber) {
    var scores = { sensitive: 0, dehydrated: 0, breakouts: 0, barrier: 0, inconsistent: 0, simple: 0, wantsResults: 0, bodyBreakouts: 0, bodyDryness: 0, bodySensitivity: 0, bodyTexture: 0 };
    applyMap(scores, Q1_MAP, answers.q1);
    var hasNoBody = bodyAnswers.indexOf('no_body_concerns') > -1;
    var bodyList  = hasNoBody ? ['no_body_concerns'] : bodyAnswers;
    bodyList.forEach(function(k) { applyMap(scores, Q2_MAP, k); });
    applyMap(scores, Q3_MAP, answers.q3);
    applyMap(scores, Q4_MAP, answers.q4);
    applyMap(scores, Q5_MAP, answers.q5);
    applyMap(scores, Q6_MAP, answers.q6);
    var routineLevel = Q6_ROUTINE_LEVEL[answers.q6] || 'some';
    goalAnswers.forEach(function(k) { applyMap(scores, Q7_MAP, k); });
    var goalFlags = {
      wantsSimple:     goalAnswers.indexOf('simple_easy_routines') > -1,
      wantsResults:    goalAnswers.indexOf('clear_visible_results') > -1 || goalAnswers.indexOf('hydration_that_lasts') > -1,
      wantsGentle:     goalAnswers.indexOf('gentle_wont_irritate') > -1 || goalAnswers.indexOf('trust_for_sensitive_skin') > -1,
      hasBodyDryness:  bodyAnswers.indexOf('dry_itchy_skin') > -1,
      hasBodyConcerns: !hasNoBody && bodyAnswers.length > 0,
    };
    var bodyProds      = getBodyProds(bodyAnswers, hasNoBody);
    var profile        = getSkinProfile(scores, ageNumber);
    var rec            = getRoutineAndBundles(scores, routineLevel, goalFlags, ageNumber, bodyProds.length);
    var serumEducation = getSerumEducation(scores, ageNumber, rec.routine);
    return {
      scores: scores, profile: profile, profileCopy: PROFILE_COPY[profile],
      routineLevel: rec.routineLevel, routineCopy: ROUTINE_COPY[rec.routineLevel] || ROUTINE_COPY['simple'],
      routine: rec.routine, primaryBundle: rec.primaryBundle, upgradeBundle: rec.upgradeBundle,
      bodyProds: bodyProds, serumEducation: serumEducation,
    };
  }

  var currentQ = 0; var answers = {}; var bodyAnswers = []; var goalAnswers = [];
  var ageKey = ''; var ageNumber = 0; var userEmail = ''; var userFName = '';

  var $progress      = document.getElementById('kq-progress');
  var $progressFill  = document.getElementById('kq-progress-fill');
  var $progressLabel = document.getElementById('kq-progress-label');
  var $qContainer    = document.getElementById('kq-question-container');
  var $btnBack       = document.getElementById('kq-back');
  var $btnNext       = document.getElementById('kq-next');
  var $startBtn      = document.getElementById('kq-start');
  var $retakeBtn     = document.getElementById('kq-retake');
  var $emailInput    = document.getElementById('kq-email');
  var $fnameInput    = document.getElementById('kq-fname');
  var $emailBtn      = document.getElementById('kq-email-submit');
  var $emailError    = document.getElementById('kq-email-error');

  function showScreen(id) {
    document.querySelectorAll('.kq-screen').forEach(function(s) { s.classList.remove('active'); });
    document.getElementById(id).classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function updateProgress() {
    $progressFill.style.width = (currentQ / QUESTIONS.length * 100) + '%';
    $progressLabel.textContent = 'Question ' + (currentQ + 1) + ' of ' + QUESTIONS.length;
    $progress.classList.add('visible');
  }
  function hideProgress() { $progress.classList.remove('visible'); }
  function hasAnswer(q) {
    if (q.id === 'q2_body') return bodyAnswers.length > 0;
    if (q.id === 'q7')      return goalAnswers.length > 0;
    return !!answers[q.id];
  }

  function renderQuestion(index) {
    var q = QUESTIONS[index]; var isMulti = q.multi === true; var isLast = index === QUESTIONS.length - 1;
    var optionsHTML = q.options.map(function(opt, i) {
      var sel = '';
      if (q.id === 'q2_body') sel = bodyAnswers.indexOf(opt.key) > -1 ? 'selected' : '';
      else if (q.id === 'q7') sel = goalAnswers.indexOf(opt.key) > -1 ? 'selected' : '';
      else sel = answers[q.id] === opt.key ? 'selected' : '';
      var checkClass = isMulti ? 'kq-option__check kq-option__check--multi' : 'kq-option__check';
      return '<button class="kq-option ' + sel + '" data-index="' + i + '" type="button"><span class="kq-option__label">' + opt.label + '</span><span class="' + checkClass + '"></span></button>';
    }).join('');
    $qContainer.innerHTML = '<div class="kq-question"><p class="kq-eyebrow">Question ' + (index + 1) + ' of ' + QUESTIONS.length + '</p><h2 class="kq-question__text">' + q.text + '</h2>' + (isMulti ? '<p class="kq-multi-hint">Select all that apply</p>' : '') + '<div class="kq-options">' + optionsHTML + '</div></div>';
    $qContainer.querySelectorAll('.kq-option').forEach(function(btn) { btn.addEventListener('click', function() { selectOption(btn, q); }); });
    $btnNext.disabled = !hasAnswer(q);
    $btnBack.style.visibility = index === 0 ? 'hidden' : 'visible';
    $btnNext.innerHTML = isLast ? 'See My Results &#8594;' : 'Next &#8594;';
  }

  function selectOption(btn, q) {
    var idx = parseInt(btn.getAttribute('data-index'), 10); var opt = q.options[idx];
    if (q.id === 'q2_body') {
      if (opt.key === 'no_body_concerns') {
        bodyAnswers = ['no_body_concerns'];
        $qContainer.querySelectorAll('.kq-option').forEach(function(b, i) { b.classList.toggle('selected', i === idx); });
      } else {
        var noIdx = bodyAnswers.indexOf('no_body_concerns'); if (noIdx > -1) bodyAnswers.splice(noIdx, 1);
        var exists = bodyAnswers.indexOf(opt.key);
        if (exists > -1) { bodyAnswers.splice(exists, 1); btn.classList.remove('selected'); }
        else { bodyAnswers.push(opt.key); btn.classList.add('selected'); }
        $qContainer.querySelectorAll('.kq-option').forEach(function(b) { if (b.getAttribute('data-index') === String(q.options.length - 1)) b.classList.remove('selected'); });
      }
      $btnNext.disabled = bodyAnswers.length === 0; return;
    }
    if (q.id === 'q7') {
      var gi = goalAnswers.indexOf(opt.key);
      if (gi > -1) { goalAnswers.splice(gi, 1); btn.classList.remove('selected'); }
      else { goalAnswers.push(opt.key); btn.classList.add('selected'); }
      $btnNext.disabled = goalAnswers.length === 0; return;
    }
    $qContainer.querySelectorAll('.kq-option').forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected'); answers[q.id] = opt.key;
    if (q.id === 'q8_age') { ageKey = opt.key; ageNumber = opt.ageNumber || 0; }
    $btnNext.disabled = false;
  }

  $startBtn.addEventListener('click', function() { currentQ = 0; showScreen('screen-questions'); updateProgress(); renderQuestion(0); });
  $btnNext.addEventListener('click', function() {
    if (currentQ < QUESTIONS.length - 1) { currentQ++; updateProgress(); renderQuestion(currentQ); }
    else { hideProgress(); showScreen('screen-email'); }
  });
  $btnBack.addEventListener('click', function() { if (currentQ > 0) { currentQ--; updateProgress(); renderQuestion(currentQ); } });
  if ($retakeBtn) {
    $retakeBtn.addEventListener('click', function() {
      answers = {}; bodyAnswers = []; goalAnswers = []; ageKey = ''; ageNumber = 0; currentQ = 0; userEmail = ''; userFName = '';
      if ($emailInput) $emailInput.value = ''; if ($fnameInput) $fnameInput.value = '';
      hideProgress(); showScreen('screen-intro');
    });
  }

  function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

  function subscribeToKlaviyo(email, fname) {
    var settings = window.KALADE_SETTINGS || {};
    var listId   = settings.klaviyoListId;
    var pubKey   = settings.klaviyoPublicKey;
    if (!listId || !pubKey) { console.warn('[Kalade Quiz] Missing listId or pubKey'); return; }
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Kalade Skin Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, first_name: fname || '' }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + pubKey, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function(res) {
      if (res.ok) { console.log('[Kalade Quiz] Subscribed successfully'); }
      else { res.text().then(function(t) { console.warn('[Kalade Quiz] Subscribe failed ' + res.status + ':', t); }); }
    }).catch(function(err) { console.warn('[Kalade Quiz] Subscribe error:', err); });
  }

  function submitEmail() {
    var email = $emailInput ? $emailInput.value.trim() : '';
    if (!isValidEmail(email)) {
      if ($emailInput) $emailInput.classList.add('error');
      if ($emailError) $emailError.textContent = 'Please enter a valid email address.';
      return;
    }
    userEmail = email; userFName = $fnameInput ? $fnameInput.value.trim() : '';
    if ($emailInput) $emailInput.classList.remove('error');
    if ($emailError) $emailError.textContent = '';
    subscribeToKlaviyo(userEmail, userFName);
    showScreen('screen-loading');
    setTimeout(processResults, 1600);
  }

  if ($emailBtn) { $emailBtn.addEventListener('click', function() { submitEmail(); }); }
  if ($emailInput) {
    $emailInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') submitEmail(); });
    $emailInput.addEventListener('input', function() { $emailInput.classList.remove('error'); if ($emailError) $emailError.textContent = ''; });
  }

  function fireKlaviyoEvents(results) {
    var pc       = results.profileCopy;
    var routine  = results.routine.map(function(item) { return PRODUCTS[item.product] ? PRODUCTS[item.product].name : item.product; });
    var bodyProds = (results.bodyProds || []).map(function(key) { return PRODUCTS[key] ? PRODUCTS[key].name : key; });
    var primary  = BUNDLE_COPY[results.primaryBundle];
    var upgrade  = results.upgradeBundle ? BUNDLE_COPY[results.upgradeBundle] : null;
    var pubKey   = (window.KALADE_SETTINGS || {}).klaviyoPublicKey || 'Uxz8E8';

    var eventProps = {
      email:              userEmail,
      first_name:         userFName || '',
      age_range:          ageKey,
      skin_profile:       pc.title,
      profile_why:        pc.why,
      profile_mistake:    pc.mistake,
      routine_level:      results.routineLevel,
      routine_products:   routine.join(', '),
      body_products:      bodyProds.join(', '),
      primary_bundle:     primary ? primary.name : '',
      upgrade_bundle:     upgrade ? upgrade.name : '',
      primary_bundle_url: primary ? 'https://kalade.com' + primary.url : '',
      upgrade_bundle_url: upgrade ? 'https://kalade.com' + upgrade.url : '',
      serum_education:    results.serumEducation.map(function(b) { return b.title; }).join(', '),
    };

    /* Fire via Klaviyo client events API — works without onsite JS */
    fetch('https://a.klaviyo.com/client/events/?company_id=' + pubKey, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Kalade Skin Quiz Completed' } } },
            profile: { data: { type: 'profile', attributes: { email: userEmail, first_name: userFName || '' } } },
            properties: eventProps,
          }
        }
      })
    }).then(function(res) {
      if (res.ok) { console.log('[Kalade Quiz] Track event fired successfully'); }
      else { res.text().then(function(t) { console.warn('[Kalade Quiz] Track failed:', res.status, t); }); }
    }).catch(function(err) { console.warn('[Kalade Quiz] Track error:', err); });

    /* Also try _learnq if available */
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['identify', { '$email': userEmail, '$first_name': userFName || undefined, 'Kalade Quiz Completed': true, 'Kalade Skin Profile': pc.title, 'Kalade Routine Level': results.routineLevel, 'Kalade Age Range': ageKey }]);
      window._learnq.push(['track', 'Kalade Skin Quiz Completed', eventProps]);
    }
  }

  function processResults() {
    var results = computeResults(answers, bodyAnswers, goalAnswers, ageKey, ageNumber);
    renderResults(results);
    showScreen('screen-results');
    setTimeout(function() { fireKlaviyoEvents(results); }, 800);
  }

  function el(tag, cls, html) { return '<' + tag + (cls ? ' class="' + cls + '"' : '') + '>' + (html || '') + '</' + tag + '>'; }

  function productCard(step, productKey, index) {
    var p = PRODUCTS[productKey]; if (!p) return '';
    return '<div class="kq-product-card" style="animation-delay:' + (index * 60) + 'ms"><a href="' + p.url + '" class="kq-product-card__img-wrap"><img src="' + IMAGES[p.img] + '" alt="' + p.name + '" loading="lazy"></a><div class="kq-product-card__body">' + el('p','kq-product-card__step', step) + el('p','kq-product-card__name', p.name) + el('p','kq-product-card__desc', p.desc) + '<a href="' + p.url + '" class="kq-product-card__cta">Shop Now &#8594;</a></div></div>';
  }

  function bundleCard(key, isSecondary) {
    if (!key || !BUNDLE_COPY[key]) return '';
    var b = BUNDLE_COPY[key]; var img = BUNDLE_IMAGES[b.img] || '';
    return '<div class="kq-bundle-card' + (isSecondary ? ' kq-bundle-card--secondary' : '') + '">' + (img ? '<div class="kq-bundle-card__img-wrap"><img src="' + img + '" alt="' + b.name + '" loading="lazy"></div>' : '') + '<div class="kq-bundle-card__body">' + el('p','kq-bundle-card__name', b.name) + el('p','kq-bundle-card__headline', b.headline) + el('p','kq-bundle-card__desc', b.desc) + '</div><div class="kq-bundle-card__footer"><a href="' + b.url + '" class="kq-bundle-card__cta">' + b.cta + '</a></div></div>';
  }

  function set(id, html, isText) { var node = document.getElementById(id); if (!node) return; if (isText) node.textContent = html; else node.innerHTML = html; }

  function renderResults(r) {
    var pc = r.profileCopy; var rc = r.routineCopy;
    set('kq-email-display', userEmail, true);
    set('kq-results-skin-type', 'You have <em>' + pc.title + '</em>');
    set('kq-profile-why', pc.why, true); set('kq-profile-mistake', pc.mistake, true);
    set('kq-routine-heading', rc.heading, true);
    set('kq-routine-note', pc.routineNote + ' ' + rc.note, true);
    var allCards = r.routine.map(function(item, i) { return productCard(item.step, item.product, i); });
    if (r.bodyProds && r.bodyProds.length > 0) { r.bodyProds.forEach(function(key, i) { allCards.push(productCard('Body Add-On', key, r.routine.length + i)); }); }
    set('kq-routine-grid', allCards.join(''));
    var eduSection = document.getElementById('kq-education-section');
    if (r.serumEducation && r.serumEducation.length > 0) {
      var cards = r.serumEducation.map(function(block) { return '<div class="kq-education-card"><p class="kq-education-card__title">' + block.title + '</p><p class="kq-education-card__body">' + block.body + '</p></div>'; }).join('');
      if (eduSection) { eduSection.innerHTML = '<h2 class="kq-section__title kq-education-heading">Why these products were recommended for your skin</h2><div class="kq-education-grid">' + cards + '</div>'; eduSection.style.display = ''; }
    } else { if (eduSection) eduSection.style.display = 'none'; }
    var bundleHTML = bundleCard(r.primaryBundle, false);
    if (r.upgradeBundle) bundleHTML += bundleCard(r.upgradeBundle, true);
    set('kq-bundle-grid', bundleHTML);
    var bodySection = document.getElementById('kq-body-addons-section');
    if (bodySection) bodySection.style.display = 'none';
  }

})();
});